'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.createOperation = void 0;
var tslib_1 = require('tslib');
var typed_redux_saga_1 = require('typed-redux-saga');
var reducer_1 = require('../reducer');
var prepareCall_1 = require('./prepareCall');
var addOrUpdateOperation = reducer_1.actions.addOrUpdateOperation,
    removeOperation = reducer_1.actions.removeOperation;
function defaultUpdateStrategy(operation) {
    return operation;
}
function createOperation(id, genFunc, updateStrategy) {
    if (updateStrategy === void 0) {
        updateStrategy = defaultUpdateStrategy;
    }
    function run() {
        var _i, error, result, operation, e_1;
        var args = [];
        for (_i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    error = undefined;
                    result = undefined;
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            (0, typed_redux_saga_1.call)(updateStrategy, {
                                id: id,
                                isLoading: true,
                                isError: false,
                                error: error,
                                result: result,
                                args: args,
                            })
                        ),
                    ];
                case 1:
                    operation = _a.sent();
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)((0, typed_redux_saga_1.put)(addOrUpdateOperation(operation))),
                    ];
                case 2:
                    _a.sent();
                    if (operation.isBlocked) {
                        return [2 /*return*/, operation.result];
                    }
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, 6, 9]);
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            typed_redux_saga_1.call.apply(
                                void 0,
                                (0, tslib_1.__spreadArray)(
                                    [prepareCall_1.prepareCall.call(this, genFunc)],
                                    (0, tslib_1.__read)(args),
                                    false
                                )
                            )
                        ),
                    ];
                case 4:
                    result = _a.sent();
                    return [3 /*break*/, 9];
                case 5:
                    e_1 = _a.sent();
                    error = e_1;
                    throw e_1;
                case 6:
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            (0, typed_redux_saga_1.call)(updateStrategy, {
                                id: id,
                                isError: !!error,
                                error: error,
                                isLoading: false,
                                result: result,
                                args: args,
                            })
                        ),
                    ];
                case 7:
                    operation = _a.sent();
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)((0, typed_redux_saga_1.put)(addOrUpdateOperation(operation))),
                    ];
                case 8:
                    _a.sent();
                    return [7 /*endfinally*/];
                case 9:
                    return [2 /*return*/, result];
            }
        });
    }
    function destroy() {
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [5 /*yield**/, (0, tslib_1.__values)((0, typed_redux_saga_1.put)(removeOperation(id)))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }
    return {
        id: id,
        run: run,
        destroy: destroy,
    };
}
exports.createOperation = createOperation;
